import { render } from "./RegistrationUserStepThree.vue?vue&type=template&id=c747d9aa&scoped=true"
import script from "./RegistrationUserStepThree.vue?vue&type=script&lang=js"
export * from "./RegistrationUserStepThree.vue?vue&type=script&lang=js"

import "./RegistrationUserStepThree.vue?vue&type=style&index=0&id=c747d9aa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c747d9aa"]])

export default __exports__